import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { getRouteAccess } from '~/configs/route-access.config'
import { useSessionStore } from '~/stores/session'

type RequireRouteAccessProps = {
  children: ReactNode
}

export function RequireRouteAccess({ children }: RequireRouteAccessProps) {
  const location = useLocation()
  const user = useSessionStore((state) => state.user)
  const routeAccess = getRouteAccess(location.pathname)

  if (routeAccess?.role && user?.role !== routeAccess.role) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
